<template>
    <BaseModal
        :isVisible="modalStatus"
        title="Solicitar Carona"
        size="xl"
        @close="close"
    >
        <template v-slot:content>

            <div class="vehicle-header mb-4">
                <div class="row">
                    <div class="col-md-12">
                        Você está solicitando uma carona para:
                        <strong>{{
                                dataModal.city_destination.description
                                }}</strong>
                        no dia
                        <strong>{{ dataModal.reserve.retreat_date }}</strong>
                    </div>
                    <div class="col-md-12 mt-3">
                        <label
                            for="requester_observation"
                        >Deseja enviar alguma observação ao
                         {{ dataModal.reserve.user.name }}?
                        </label
                        >
                        <textarea
                            name="requester_observation"
                            class="form-control"
                            id="requester_observation"
                            cols="30"
                            rows="10"
                            v-model="dataModal.requester_observation"
                        ></textarea>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12 text-right mt-3">
                        <button
                            type="button"
                            class="btn btn-primary"
                            @click="$emit('get-ride', dataModal)"
                        >
                            Pedir Carona
                        </button>
                    </div>
                </div>
            </div>

        </template>
    </BaseModal>
</template>

<script>
import BaseModal from "../Base/BaseModal.vue";
import VehicleHeader from "../Modals/Checklist/VehicleHeader.vue";
import CheckForm from "../Modals/Checklist/CheckForm.vue";

export default {
    components: {
        BaseModal,
        VehicleHeader,
        CheckForm
    },

    props: {
        modalStatus: {
            type: Boolean,
            default: false
        },
        divergence: {
            type: Object,
            required: true
        },
    },

    emits: ["get-ride"],

    data() {
        return {
            observation: '',
            dataModal: {},
        }
    },

    watch: {
        divergence: {
            handler(newValue) {
                this.dataModal = newValue;
            },
            immediate: true
        }
    },

    methods: {
        close() {
            this.$emit("close");
        },
    },
};
</script>

<style scoped>
.comment {
    margin-top: 15px;
    background-color: #efefef;
    padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/RequestRideModal.vue